// source: external/user/user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var xcommon_user_pb = require('../../xcommon/user_pb.js');
goog.object.extend(proto, xcommon_user_pb);
var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js');
goog.object.extend(proto, xcommon_ticket_pb);
var xcommon_module_pb = require('../../xcommon/module_pb.js');
goog.object.extend(proto, xcommon_module_pb);
var xcommon_enum_pb = require('../../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
var xcommon_common_pb = require('../../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
goog.exportSymbol('proto.userepb.BatchGetLoginInfoReq', null, global);
goog.exportSymbol('proto.userepb.BatchGetLoginInfoResp', null, global);
goog.exportSymbol('proto.userepb.BatchUpdateUserWorkStatusReq', null, global);
goog.exportSymbol('proto.userepb.ChangePasswordReq', null, global);
goog.exportSymbol('proto.userepb.CommitTwoFactAuthCodeReq', null, global);
goog.exportSymbol('proto.userepb.CommitTwoFactAuthCodeResp', null, global);
goog.exportSymbol('proto.userepb.CreateUserReq', null, global);
goog.exportSymbol('proto.userepb.CreateUserResp', null, global);
goog.exportSymbol('proto.userepb.DeleteUserReq', null, global);
goog.exportSymbol('proto.userepb.EnterSystemReq', null, global);
goog.exportSymbol('proto.userepb.EnterSystemResp', null, global);
goog.exportSymbol('proto.userepb.GetOptionsForAttendanceReportReq', null, global);
goog.exportSymbol('proto.userepb.GetOptionsForAttendanceReportResp', null, global);
goog.exportSymbol('proto.userepb.GetOutSourceInfoReq', null, global);
goog.exportSymbol('proto.userepb.GetOutSourceInfoResp', null, global);
goog.exportSymbol('proto.userepb.GetTwoFactAuthQRReq', null, global);
goog.exportSymbol('proto.userepb.GetTwoFactAuthQRResp', null, global);
goog.exportSymbol('proto.userepb.GetUserByEmailReq', null, global);
goog.exportSymbol('proto.userepb.GetUserByEmployeeIDReq', null, global);
goog.exportSymbol('proto.userepb.GetUserByMobileReq', null, global);
goog.exportSymbol('proto.userepb.GetUserListMiniResp', null, global);
goog.exportSymbol('proto.userepb.GetUserListReq', null, global);
goog.exportSymbol('proto.userepb.GetUserListResp', null, global);
goog.exportSymbol('proto.userepb.GetUserResp', null, global);
goog.exportSymbol('proto.userepb.ListGroupAttendanceReq', null, global);
goog.exportSymbol('proto.userepb.ListGroupAttendanceResp', null, global);
goog.exportSymbol('proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreDayReq', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreDayResp', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreRangeReq', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreRangeResp', null, global);
goog.exportSymbol('proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow', null, global);
goog.exportSymbol('proto.userepb.LoginReq', null, global);
goog.exportSymbol('proto.userepb.LoginResp', null, global);
goog.exportSymbol('proto.userepb.MyQRResp', null, global);
goog.exportSymbol('proto.userepb.PreCreateUserResp', null, global);
goog.exportSymbol('proto.userepb.SearchUserMiniReq', null, global);
goog.exportSymbol('proto.userepb.SearchUserReq', null, global);
goog.exportSymbol('proto.userepb.StatementOfSalaryReq', null, global);
goog.exportSymbol('proto.userepb.StatementOfSalaryResp', null, global);
goog.exportSymbol('proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow', null, global);
goog.exportSymbol('proto.userepb.UpdateUserReq', null, global);
goog.exportSymbol('proto.userepb.UpdateUserStatusReq', null, global);
goog.exportSymbol('proto.userepb.VerifyPasswordReq', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.LoginReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.LoginReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.LoginReq.displayName = 'proto.userepb.LoginReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.LoginResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.LoginResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.LoginResp.displayName = 'proto.userepb.LoginResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetTwoFactAuthQRReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetTwoFactAuthQRReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetTwoFactAuthQRReq.displayName = 'proto.userepb.GetTwoFactAuthQRReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetTwoFactAuthQRResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetTwoFactAuthQRResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetTwoFactAuthQRResp.displayName = 'proto.userepb.GetTwoFactAuthQRResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.CommitTwoFactAuthCodeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.CommitTwoFactAuthCodeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.CommitTwoFactAuthCodeReq.displayName = 'proto.userepb.CommitTwoFactAuthCodeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.CommitTwoFactAuthCodeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.CommitTwoFactAuthCodeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.CommitTwoFactAuthCodeResp.displayName = 'proto.userepb.CommitTwoFactAuthCodeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.EnterSystemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.EnterSystemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.EnterSystemReq.displayName = 'proto.userepb.EnterSystemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.EnterSystemResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.EnterSystemResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.EnterSystemResp.displayName = 'proto.userepb.EnterSystemResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.MyQRResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.MyQRResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.MyQRResp.displayName = 'proto.userepb.MyQRResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.VerifyPasswordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.VerifyPasswordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.VerifyPasswordReq.displayName = 'proto.userepb.VerifyPasswordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ChangePasswordReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.ChangePasswordReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ChangePasswordReq.displayName = 'proto.userepb.ChangePasswordReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.PreCreateUserResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.PreCreateUserResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.PreCreateUserResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.PreCreateUserResp.displayName = 'proto.userepb.PreCreateUserResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetOutSourceInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetOutSourceInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetOutSourceInfoReq.displayName = 'proto.userepb.GetOutSourceInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetOutSourceInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.GetOutSourceInfoResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.GetOutSourceInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetOutSourceInfoResp.displayName = 'proto.userepb.GetOutSourceInfoResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.CreateUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.CreateUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.CreateUserReq.displayName = 'proto.userepb.CreateUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.CreateUserResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.CreateUserResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.CreateUserResp.displayName = 'proto.userepb.CreateUserResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.UpdateUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.UpdateUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.UpdateUserReq.displayName = 'proto.userepb.UpdateUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.UpdateUserStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.UpdateUserStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.UpdateUserStatusReq.displayName = 'proto.userepb.UpdateUserStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.BatchUpdateUserWorkStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.BatchUpdateUserWorkStatusReq.repeatedFields_, null);
};
goog.inherits(proto.userepb.BatchUpdateUserWorkStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.BatchUpdateUserWorkStatusReq.displayName = 'proto.userepb.BatchUpdateUserWorkStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.DeleteUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.DeleteUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.DeleteUserReq.displayName = 'proto.userepb.DeleteUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.SearchUserReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.SearchUserReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.SearchUserReq.displayName = 'proto.userepb.SearchUserReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.SearchUserMiniReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.SearchUserMiniReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.SearchUserMiniReq.displayName = 'proto.userepb.SearchUserMiniReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserByEmployeeIDReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetUserByEmployeeIDReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserByEmployeeIDReq.displayName = 'proto.userepb.GetUserByEmployeeIDReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserByMobileReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetUserByMobileReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserByMobileReq.displayName = 'proto.userepb.GetUserByMobileReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserByEmailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetUserByEmailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserByEmailReq.displayName = 'proto.userepb.GetUserByEmailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetUserResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserResp.displayName = 'proto.userepb.GetUserResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserListReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetUserListReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserListReq.displayName = 'proto.userepb.GetUserListReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserListResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.GetUserListResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.GetUserListResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserListResp.displayName = 'proto.userepb.GetUserListResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetUserListMiniResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.GetUserListMiniResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.GetUserListMiniResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetUserListMiniResp.displayName = 'proto.userepb.GetUserListMiniResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetOptionsForAttendanceReportReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.GetOptionsForAttendanceReportReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetOptionsForAttendanceReportReq.displayName = 'proto.userepb.GetOptionsForAttendanceReportReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.GetOptionsForAttendanceReportResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.GetOptionsForAttendanceReportResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.GetOptionsForAttendanceReportResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.GetOptionsForAttendanceReportResp.displayName = 'proto.userepb.GetOptionsForAttendanceReportResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListGroupAttendanceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListGroupAttendanceReq.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListGroupAttendanceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListGroupAttendanceReq.displayName = 'proto.userepb.ListGroupAttendanceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListGroupAttendanceResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListGroupAttendanceResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListGroupAttendanceResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListGroupAttendanceResp.displayName = 'proto.userepb.ListGroupAttendanceResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.displayName = 'proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.StatementOfSalaryReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.StatementOfSalaryReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.StatementOfSalaryReq.displayName = 'proto.userepb.StatementOfSalaryReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.StatementOfSalaryResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.StatementOfSalaryResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.StatementOfSalaryResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.StatementOfSalaryResp.displayName = 'proto.userepb.StatementOfSalaryResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.displayName = 'proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreRangeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListPersonalAttendancePreRangeReq.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreRangeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreRangeReq.displayName = 'proto.userepb.ListPersonalAttendancePreRangeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreRangeResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListPersonalAttendancePreRangeResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreRangeResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreRangeResp.displayName = 'proto.userepb.ListPersonalAttendancePreRangeResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.displayName = 'proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreDayReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListPersonalAttendancePreDayReq.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreDayReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreDayReq.displayName = 'proto.userepb.ListPersonalAttendancePreDayReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreDayResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.ListPersonalAttendancePreDayResp.repeatedFields_, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreDayResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreDayResp.displayName = 'proto.userepb.ListPersonalAttendancePreDayResp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.displayName = 'proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.BatchGetLoginInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.userepb.BatchGetLoginInfoReq.repeatedFields_, null);
};
goog.inherits(proto.userepb.BatchGetLoginInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.BatchGetLoginInfoReq.displayName = 'proto.userepb.BatchGetLoginInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.userepb.BatchGetLoginInfoResp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.userepb.BatchGetLoginInfoResp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.userepb.BatchGetLoginInfoResp.displayName = 'proto.userepb.BatchGetLoginInfoResp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.LoginReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.LoginReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.LoginReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.LoginReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    trackid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    password: jspb.Message.getFieldWithDefault(msg, 4, ""),
    captchaid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    captchacode: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.LoginReq}
 */
proto.userepb.LoginReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.LoginReq;
  return proto.userepb.LoginReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.LoginReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.LoginReq}
 */
proto.userepb.LoginReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrackid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaptchaid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaptchacode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.LoginReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.LoginReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.LoginReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.LoginReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrackid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCaptchaid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCaptchacode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string TrackId = 1;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getTrackid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setTrackid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ClientId = 2;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setClientid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Password = 4;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string CaptchaId = 5;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getCaptchaid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setCaptchaid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string CaptchaCode = 6;
 * @return {string}
 */
proto.userepb.LoginReq.prototype.getCaptchacode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginReq} returns this
 */
proto.userepb.LoginReq.prototype.setCaptchacode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.LoginResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.LoginResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.LoginResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.LoginResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    gototwofactauth: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    scantwofactauthqr: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    onetimetoken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.LoginResp}
 */
proto.userepb.LoginResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.LoginResp;
  return proto.userepb.LoginResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.LoginResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.LoginResp}
 */
proto.userepb.LoginResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGototwofactauth(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScantwofactauthqr(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnetimetoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.LoginResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.LoginResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.LoginResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.LoginResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getGototwofactauth();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getScantwofactauthqr();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOnetimetoken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.LoginResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.LoginResp} returns this
*/
proto.userepb.LoginResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.LoginResp} returns this
 */
proto.userepb.LoginResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.LoginResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool GotoTwoFactAuth = 2;
 * @return {boolean}
 */
proto.userepb.LoginResp.prototype.getGototwofactauth = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.userepb.LoginResp} returns this
 */
proto.userepb.LoginResp.prototype.setGototwofactauth = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool ScanTwoFactAuthQR = 3;
 * @return {boolean}
 */
proto.userepb.LoginResp.prototype.getScantwofactauthqr = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.userepb.LoginResp} returns this
 */
proto.userepb.LoginResp.prototype.setScantwofactauthqr = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string OneTimeToken = 4;
 * @return {string}
 */
proto.userepb.LoginResp.prototype.getOnetimetoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.LoginResp} returns this
 */
proto.userepb.LoginResp.prototype.setOnetimetoken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetTwoFactAuthQRReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetTwoFactAuthQRReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetTwoFactAuthQRReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetTwoFactAuthQRReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetTwoFactAuthQRReq}
 */
proto.userepb.GetTwoFactAuthQRReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetTwoFactAuthQRReq;
  return proto.userepb.GetTwoFactAuthQRReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetTwoFactAuthQRReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetTwoFactAuthQRReq}
 */
proto.userepb.GetTwoFactAuthQRReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetTwoFactAuthQRReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetTwoFactAuthQRReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetTwoFactAuthQRReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetTwoFactAuthQRReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetTwoFactAuthQRReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetTwoFactAuthQRReq} returns this
*/
proto.userepb.GetTwoFactAuthQRReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetTwoFactAuthQRReq} returns this
 */
proto.userepb.GetTwoFactAuthQRReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetTwoFactAuthQRReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetTwoFactAuthQRResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetTwoFactAuthQRResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetTwoFactAuthQRResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    qr: msg.getQr_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetTwoFactAuthQRResp}
 */
proto.userepb.GetTwoFactAuthQRResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetTwoFactAuthQRResp;
  return proto.userepb.GetTwoFactAuthQRResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetTwoFactAuthQRResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetTwoFactAuthQRResp}
 */
proto.userepb.GetTwoFactAuthQRResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setQr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetTwoFactAuthQRResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetTwoFactAuthQRResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetTwoFactAuthQRResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getQr_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.GetTwoFactAuthQRResp} returns this
*/
proto.userepb.GetTwoFactAuthQRResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetTwoFactAuthQRResp} returns this
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes QR = 2;
 * @return {!(string|Uint8Array)}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.getQr = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes QR = 2;
 * This is a type-conversion wrapper around `getQr()`
 * @return {string}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.getQr_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getQr()));
};


/**
 * optional bytes QR = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getQr()`
 * @return {!Uint8Array}
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.getQr_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getQr()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.userepb.GetTwoFactAuthQRResp} returns this
 */
proto.userepb.GetTwoFactAuthQRResp.prototype.setQr = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.CommitTwoFactAuthCodeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.CommitTwoFactAuthCodeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CommitTwoFactAuthCodeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    twofactauthcode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.CommitTwoFactAuthCodeReq}
 */
proto.userepb.CommitTwoFactAuthCodeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.CommitTwoFactAuthCodeReq;
  return proto.userepb.CommitTwoFactAuthCodeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.CommitTwoFactAuthCodeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.CommitTwoFactAuthCodeReq}
 */
proto.userepb.CommitTwoFactAuthCodeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwofactauthcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.CommitTwoFactAuthCodeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.CommitTwoFactAuthCodeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CommitTwoFactAuthCodeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getTwofactauthcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.CommitTwoFactAuthCodeReq} returns this
*/
proto.userepb.CommitTwoFactAuthCodeReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.CommitTwoFactAuthCodeReq} returns this
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string TwoFactAuthCode = 2;
 * @return {string}
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.getTwofactauthcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CommitTwoFactAuthCodeReq} returns this
 */
proto.userepb.CommitTwoFactAuthCodeReq.prototype.setTwofactauthcode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.CommitTwoFactAuthCodeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.CommitTwoFactAuthCodeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CommitTwoFactAuthCodeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    decision: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.CommitTwoFactAuthCodeResp}
 */
proto.userepb.CommitTwoFactAuthCodeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.CommitTwoFactAuthCodeResp;
  return proto.userepb.CommitTwoFactAuthCodeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.CommitTwoFactAuthCodeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.CommitTwoFactAuthCodeResp}
 */
proto.userepb.CommitTwoFactAuthCodeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.Decision} */ (reader.readEnum());
      msg.setDecision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.CommitTwoFactAuthCodeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.CommitTwoFactAuthCodeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CommitTwoFactAuthCodeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDecision();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.CommitTwoFactAuthCodeResp} returns this
*/
proto.userepb.CommitTwoFactAuthCodeResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.CommitTwoFactAuthCodeResp} returns this
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.Decision Decision = 2;
 * @return {!proto.xcommon.Decision}
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.getDecision = function() {
  return /** @type {!proto.xcommon.Decision} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.Decision} value
 * @return {!proto.userepb.CommitTwoFactAuthCodeResp} returns this
 */
proto.userepb.CommitTwoFactAuthCodeResp.prototype.setDecision = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.EnterSystemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.EnterSystemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.EnterSystemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.EnterSystemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.EnterSystemReq}
 */
proto.userepb.EnterSystemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.EnterSystemReq;
  return proto.userepb.EnterSystemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.EnterSystemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.EnterSystemReq}
 */
proto.userepb.EnterSystemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.EnterSystemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.EnterSystemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.EnterSystemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.EnterSystemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.EnterSystemReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.EnterSystemReq} returns this
*/
proto.userepb.EnterSystemReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.EnterSystemReq} returns this
 */
proto.userepb.EnterSystemReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.EnterSystemReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.EnterSystemResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.EnterSystemResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.EnterSystemResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.EnterSystemResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    successdata: (f = msg.getSuccessdata()) && xcommon_user_pb.LoginSuccessData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.EnterSystemResp}
 */
proto.userepb.EnterSystemResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.EnterSystemResp;
  return proto.userepb.EnterSystemResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.EnterSystemResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.EnterSystemResp}
 */
proto.userepb.EnterSystemResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_user_pb.LoginSuccessData;
      reader.readMessage(value,xcommon_user_pb.LoginSuccessData.deserializeBinaryFromReader);
      msg.setSuccessdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.EnterSystemResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.EnterSystemResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.EnterSystemResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.EnterSystemResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getSuccessdata();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_user_pb.LoginSuccessData.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.EnterSystemResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.EnterSystemResp} returns this
*/
proto.userepb.EnterSystemResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.EnterSystemResp} returns this
 */
proto.userepb.EnterSystemResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.EnterSystemResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.LoginSuccessData SuccessData = 2;
 * @return {?proto.xcommon.LoginSuccessData}
 */
proto.userepb.EnterSystemResp.prototype.getSuccessdata = function() {
  return /** @type{?proto.xcommon.LoginSuccessData} */ (
    jspb.Message.getWrapperField(this, xcommon_user_pb.LoginSuccessData, 2));
};


/**
 * @param {?proto.xcommon.LoginSuccessData|undefined} value
 * @return {!proto.userepb.EnterSystemResp} returns this
*/
proto.userepb.EnterSystemResp.prototype.setSuccessdata = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.EnterSystemResp} returns this
 */
proto.userepb.EnterSystemResp.prototype.clearSuccessdata = function() {
  return this.setSuccessdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.EnterSystemResp.prototype.hasSuccessdata = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.MyQRResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.MyQRResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.MyQRResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.MyQRResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    qr: msg.getQr_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.MyQRResp}
 */
proto.userepb.MyQRResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.MyQRResp;
  return proto.userepb.MyQRResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.MyQRResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.MyQRResp}
 */
proto.userepb.MyQRResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setQr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.MyQRResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.MyQRResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.MyQRResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.MyQRResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getQr_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.MyQRResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.MyQRResp} returns this
*/
proto.userepb.MyQRResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.MyQRResp} returns this
 */
proto.userepb.MyQRResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.MyQRResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes QR = 2;
 * @return {!(string|Uint8Array)}
 */
proto.userepb.MyQRResp.prototype.getQr = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes QR = 2;
 * This is a type-conversion wrapper around `getQr()`
 * @return {string}
 */
proto.userepb.MyQRResp.prototype.getQr_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getQr()));
};


/**
 * optional bytes QR = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getQr()`
 * @return {!Uint8Array}
 */
proto.userepb.MyQRResp.prototype.getQr_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getQr()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.userepb.MyQRResp} returns this
 */
proto.userepb.MyQRResp.prototype.setQr = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.VerifyPasswordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.VerifyPasswordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.VerifyPasswordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.VerifyPasswordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    password: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.VerifyPasswordReq}
 */
proto.userepb.VerifyPasswordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.VerifyPasswordReq;
  return proto.userepb.VerifyPasswordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.VerifyPasswordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.VerifyPasswordReq}
 */
proto.userepb.VerifyPasswordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.VerifyPasswordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.VerifyPasswordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.VerifyPasswordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.VerifyPasswordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.VerifyPasswordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.VerifyPasswordReq} returns this
*/
proto.userepb.VerifyPasswordReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.VerifyPasswordReq} returns this
 */
proto.userepb.VerifyPasswordReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.VerifyPasswordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Password = 2;
 * @return {string}
 */
proto.userepb.VerifyPasswordReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.VerifyPasswordReq} returns this
 */
proto.userepb.VerifyPasswordReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ChangePasswordReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ChangePasswordReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ChangePasswordReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ChangePasswordReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    newpassword: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ChangePasswordReq}
 */
proto.userepb.ChangePasswordReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ChangePasswordReq;
  return proto.userepb.ChangePasswordReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ChangePasswordReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ChangePasswordReq}
 */
proto.userepb.ChangePasswordReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewpassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ChangePasswordReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ChangePasswordReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ChangePasswordReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ChangePasswordReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getNewpassword();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.ChangePasswordReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.ChangePasswordReq} returns this
*/
proto.userepb.ChangePasswordReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ChangePasswordReq} returns this
 */
proto.userepb.ChangePasswordReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ChangePasswordReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string NewPassword = 3;
 * @return {string}
 */
proto.userepb.ChangePasswordReq.prototype.getNewpassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ChangePasswordReq} returns this
 */
proto.userepb.ChangePasswordReq.prototype.setNewpassword = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.PreCreateUserResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.PreCreateUserResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.PreCreateUserResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.PreCreateUserResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.PreCreateUserResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    defaultpassword: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usergroupinfosList: jspb.Message.toObjectList(msg.getUsergroupinfosList(),
    xcommon_module_pb.Meta.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.PreCreateUserResp}
 */
proto.userepb.PreCreateUserResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.PreCreateUserResp;
  return proto.userepb.PreCreateUserResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.PreCreateUserResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.PreCreateUserResp}
 */
proto.userepb.PreCreateUserResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultpassword(value);
      break;
    case 3:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addUsergroupinfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.PreCreateUserResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.PreCreateUserResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.PreCreateUserResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.PreCreateUserResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getDefaultpassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsergroupinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.PreCreateUserResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.PreCreateUserResp} returns this
*/
proto.userepb.PreCreateUserResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.PreCreateUserResp} returns this
 */
proto.userepb.PreCreateUserResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.PreCreateUserResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string DefaultPassword = 2;
 * @return {string}
 */
proto.userepb.PreCreateUserResp.prototype.getDefaultpassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.PreCreateUserResp} returns this
 */
proto.userepb.PreCreateUserResp.prototype.setDefaultpassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated xcommon.Meta UserGroupInfos = 3;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.userepb.PreCreateUserResp.prototype.getUsergroupinfosList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 3));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.userepb.PreCreateUserResp} returns this
*/
proto.userepb.PreCreateUserResp.prototype.setUsergroupinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.userepb.PreCreateUserResp.prototype.addUsergroupinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.PreCreateUserResp} returns this
 */
proto.userepb.PreCreateUserResp.prototype.clearUsergroupinfosList = function() {
  return this.setUsergroupinfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetOutSourceInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetOutSourceInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetOutSourceInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOutSourceInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    exectype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetOutSourceInfoReq}
 */
proto.userepb.GetOutSourceInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetOutSourceInfoReq;
  return proto.userepb.GetOutSourceInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetOutSourceInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetOutSourceInfoReq}
 */
proto.userepb.GetOutSourceInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetOutSourceInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetOutSourceInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetOutSourceInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOutSourceInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetOutSourceInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetOutSourceInfoReq} returns this
*/
proto.userepb.GetOutSourceInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetOutSourceInfoReq} returns this
 */
proto.userepb.GetOutSourceInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetOutSourceInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.ExecType ExecType = 2;
 * @return {!proto.xcommon.ExecType}
 */
proto.userepb.GetOutSourceInfoReq.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.userepb.GetOutSourceInfoReq} returns this
 */
proto.userepb.GetOutSourceInfoReq.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.GetOutSourceInfoResp.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetOutSourceInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetOutSourceInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetOutSourceInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOutSourceInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errmsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    companyinfosList: jspb.Message.toObjectList(msg.getCompanyinfosList(),
    xcommon_module_pb.Meta.toObject, includeInstance),
    usergroupinfosList: jspb.Message.toObjectList(msg.getUsergroupinfosList(),
    xcommon_module_pb.Meta.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetOutSourceInfoResp}
 */
proto.userepb.GetOutSourceInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetOutSourceInfoResp;
  return proto.userepb.GetOutSourceInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetOutSourceInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetOutSourceInfoResp}
 */
proto.userepb.GetOutSourceInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrmsg(value);
      break;
    case 3:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addCompanyinfos(value);
      break;
    case 4:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addUsergroupinfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetOutSourceInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetOutSourceInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetOutSourceInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOutSourceInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getErrmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompanyinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
  f = message.getUsergroupinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 Code = 1;
 * @return {number}
 */
proto.userepb.GetOutSourceInfoResp.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
 */
proto.userepb.GetOutSourceInfoResp.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ErrMsg = 2;
 * @return {string}
 */
proto.userepb.GetOutSourceInfoResp.prototype.getErrmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
 */
proto.userepb.GetOutSourceInfoResp.prototype.setErrmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated xcommon.Meta CompanyInfos = 3;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.userepb.GetOutSourceInfoResp.prototype.getCompanyinfosList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 3));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
*/
proto.userepb.GetOutSourceInfoResp.prototype.setCompanyinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.userepb.GetOutSourceInfoResp.prototype.addCompanyinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
 */
proto.userepb.GetOutSourceInfoResp.prototype.clearCompanyinfosList = function() {
  return this.setCompanyinfosList([]);
};


/**
 * repeated xcommon.Meta UserGroupInfos = 4;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.userepb.GetOutSourceInfoResp.prototype.getUsergroupinfosList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 4));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
*/
proto.userepb.GetOutSourceInfoResp.prototype.setUsergroupinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.userepb.GetOutSourceInfoResp.prototype.addUsergroupinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.GetOutSourceInfoResp} returns this
 */
proto.userepb.GetOutSourceInfoResp.prototype.clearUsergroupinfosList = function() {
  return this.setUsergroupinfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.CreateUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.CreateUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.CreateUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CreateUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    employeeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 6, ""),
    password: jspb.Message.getFieldWithDefault(msg, 7, ""),
    secondaryverify: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    exectype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    company: (f = msg.getCompany()) && xcommon_module_pb.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.CreateUserReq}
 */
proto.userepb.CreateUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.CreateUserReq;
  return proto.userepb.CreateUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.CreateUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.CreateUserReq}
 */
proto.userepb.CreateUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSecondaryverify(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    case 10:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.CreateUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.CreateUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.CreateUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CreateUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSecondaryverify();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.CreateUserReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.CreateUserReq} returns this
*/
proto.userepb.CreateUserReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.CreateUserReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string EmployeeId = 2;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Mobile = 4;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string UserGroup = 6;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Password = 7;
 * @return {string}
 */
proto.userepb.CreateUserReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool SecondaryVerify = 8;
 * @return {boolean}
 */
proto.userepb.CreateUserReq.prototype.getSecondaryverify = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setSecondaryverify = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional xcommon.ExecType ExecType = 9;
 * @return {!proto.xcommon.ExecType}
 */
proto.userepb.CreateUserReq.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional xcommon.Meta Company = 10;
 * @return {?proto.xcommon.Meta}
 */
proto.userepb.CreateUserReq.prototype.getCompany = function() {
  return /** @type{?proto.xcommon.Meta} */ (
    jspb.Message.getWrapperField(this, xcommon_module_pb.Meta, 10));
};


/**
 * @param {?proto.xcommon.Meta|undefined} value
 * @return {!proto.userepb.CreateUserReq} returns this
*/
proto.userepb.CreateUserReq.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.CreateUserReq} returns this
 */
proto.userepb.CreateUserReq.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.CreateUserReq.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.CreateUserResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.CreateUserResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.CreateUserResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CreateUserResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.CreateUserResp}
 */
proto.userepb.CreateUserResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.CreateUserResp;
  return proto.userepb.CreateUserResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.CreateUserResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.CreateUserResp}
 */
proto.userepb.CreateUserResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.CreateUserResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.CreateUserResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.CreateUserResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.CreateUserResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.CreateUserResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.CreateUserResp} returns this
*/
proto.userepb.CreateUserResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.CreateUserResp} returns this
 */
proto.userepb.CreateUserResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.CreateUserResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.userepb.CreateUserResp.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.CreateUserResp} returns this
 */
proto.userepb.CreateUserResp.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.UpdateUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.UpdateUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.UpdateUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.UpdateUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    common: (f = msg.getCommon()) && xcommon_user_pb.UserCommon.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    operatorid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    password: jspb.Message.getFieldWithDefault(msg, 6, ""),
    exectype: jspb.Message.getFieldWithDefault(msg, 7, 0),
    company: (f = msg.getCompany()) && xcommon_module_pb.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.UpdateUserReq}
 */
proto.userepb.UpdateUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.UpdateUserReq;
  return proto.userepb.UpdateUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.UpdateUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.UpdateUserReq}
 */
proto.userepb.UpdateUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_user_pb.UserCommon;
      reader.readMessage(value,xcommon_user_pb.UserCommon.deserializeBinaryFromReader);
      msg.setCommon(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatorid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    case 8:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.setCompany(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.UpdateUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.UpdateUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.UpdateUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.UpdateUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getCommon();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_user_pb.UserCommon.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOperatorid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCompany();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.UpdateUserReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.UpdateUserReq} returns this
*/
proto.userepb.UpdateUserReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.UpdateUserReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.UserCommon Common = 2;
 * @return {?proto.xcommon.UserCommon}
 */
proto.userepb.UpdateUserReq.prototype.getCommon = function() {
  return /** @type{?proto.xcommon.UserCommon} */ (
    jspb.Message.getWrapperField(this, xcommon_user_pb.UserCommon, 2));
};


/**
 * @param {?proto.xcommon.UserCommon|undefined} value
 * @return {!proto.userepb.UpdateUserReq} returns this
*/
proto.userepb.UpdateUserReq.prototype.setCommon = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.clearCommon = function() {
  return this.setCommon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.UpdateUserReq.prototype.hasCommon = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.userepb.UpdateUserReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 OperatorId = 4;
 * @return {number}
 */
proto.userepb.UpdateUserReq.prototype.getOperatorid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.setOperatorid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string EmployeeId = 5;
 * @return {string}
 */
proto.userepb.UpdateUserReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Password = 6;
 * @return {string}
 */
proto.userepb.UpdateUserReq.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional xcommon.ExecType ExecType = 7;
 * @return {!proto.xcommon.ExecType}
 */
proto.userepb.UpdateUserReq.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional xcommon.Meta Company = 8;
 * @return {?proto.xcommon.Meta}
 */
proto.userepb.UpdateUserReq.prototype.getCompany = function() {
  return /** @type{?proto.xcommon.Meta} */ (
    jspb.Message.getWrapperField(this, xcommon_module_pb.Meta, 8));
};


/**
 * @param {?proto.xcommon.Meta|undefined} value
 * @return {!proto.userepb.UpdateUserReq} returns this
*/
proto.userepb.UpdateUserReq.prototype.setCompany = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.UpdateUserReq} returns this
 */
proto.userepb.UpdateUserReq.prototype.clearCompany = function() {
  return this.setCompany(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.UpdateUserReq.prototype.hasCompany = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.UpdateUserStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.UpdateUserStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.UpdateUserStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.UpdateUserStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.UpdateUserStatusReq}
 */
proto.userepb.UpdateUserStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.UpdateUserStatusReq;
  return proto.userepb.UpdateUserStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.UpdateUserStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.UpdateUserStatusReq}
 */
proto.userepb.UpdateUserStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.UserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.UpdateUserStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.UpdateUserStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.UpdateUserStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.UpdateUserStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.UpdateUserStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.UpdateUserStatusReq} returns this
*/
proto.userepb.UpdateUserStatusReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.UpdateUserStatusReq} returns this
 */
proto.userepb.UpdateUserStatusReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.UpdateUserStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.UserStatus Status = 2;
 * @return {!proto.xcommon.UserStatus}
 */
proto.userepb.UpdateUserStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.UserStatus} value
 * @return {!proto.userepb.UpdateUserStatusReq} returns this
 */
proto.userepb.UpdateUserStatusReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 UserId = 3;
 * @return {number}
 */
proto.userepb.UpdateUserStatusReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.UpdateUserStatusReq} returns this
 */
proto.userepb.UpdateUserStatusReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.BatchUpdateUserWorkStatusReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.BatchUpdateUserWorkStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchUpdateUserWorkStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    useridList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.BatchUpdateUserWorkStatusReq;
  return proto.userepb.BatchUpdateUserWorkStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.UserWorkStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUserid(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.BatchUpdateUserWorkStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.BatchUpdateUserWorkStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchUpdateUserWorkStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUseridList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
*/
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.UserWorkStatus Status = 2;
 * @return {!proto.xcommon.UserWorkStatus}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.UserWorkStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.xcommon.UserWorkStatus} value
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated int64 UserId = 3;
 * @return {!Array<number>}
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.getUseridList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.setUseridList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.addUserid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.BatchUpdateUserWorkStatusReq} returns this
 */
proto.userepb.BatchUpdateUserWorkStatusReq.prototype.clearUseridList = function() {
  return this.setUseridList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.DeleteUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.DeleteUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.DeleteUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.DeleteUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    userid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    operatorid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.DeleteUserReq}
 */
proto.userepb.DeleteUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.DeleteUserReq;
  return proto.userepb.DeleteUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.DeleteUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.DeleteUserReq}
 */
proto.userepb.DeleteUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatorid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.DeleteUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.DeleteUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.DeleteUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.DeleteUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOperatorid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.DeleteUserReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.DeleteUserReq} returns this
*/
proto.userepb.DeleteUserReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.DeleteUserReq} returns this
 */
proto.userepb.DeleteUserReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.DeleteUserReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 UserId = 2;
 * @return {number}
 */
proto.userepb.DeleteUserReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.DeleteUserReq} returns this
 */
proto.userepb.DeleteUserReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 OperatorId = 3;
 * @return {number}
 */
proto.userepb.DeleteUserReq.prototype.getOperatorid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.DeleteUserReq} returns this
 */
proto.userepb.DeleteUserReq.prototype.setOperatorid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.SearchUserReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.SearchUserReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.SearchUserReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.SearchUserReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
    exectype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    isattendance: jspb.Message.getFieldWithDefault(msg, 7, 0),
    workstatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.SearchUserReq}
 */
proto.userepb.SearchUserReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.SearchUserReq;
  return proto.userepb.SearchUserReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.SearchUserReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.SearchUserReq}
 */
proto.userepb.SearchUserReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setIsattendance(value);
      break;
    case 8:
      var value = /** @type {!proto.xcommon.UserWorkStatus} */ (reader.readEnum());
      msg.setWorkstatus(value);
      break;
    case 9:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.SearchUserReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.SearchUserReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.SearchUserReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.SearchUserReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getIsattendance();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.SearchUserReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.SearchUserReq} returns this
*/
proto.userepb.SearchUserReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.SearchUserReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.userepb.SearchUserReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.userepb.SearchUserReq} returns this
*/
proto.userepb.SearchUserReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.SearchUserReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.userepb.SearchUserReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.userepb.SearchUserReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserGroup = 5;
 * @return {string}
 */
proto.userepb.SearchUserReq.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional xcommon.ExecType ExecType = 6;
 * @return {!proto.xcommon.ExecType}
 */
proto.userepb.SearchUserReq.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional xcommon.Bool IsAttendance = 7;
 * @return {!proto.xcommon.Bool}
 */
proto.userepb.SearchUserReq.prototype.getIsattendance = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.xcommon.Bool} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setIsattendance = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional xcommon.UserWorkStatus WorkStatus = 8;
 * @return {!proto.xcommon.UserWorkStatus}
 */
proto.userepb.SearchUserReq.prototype.getWorkstatus = function() {
  return /** @type {!proto.xcommon.UserWorkStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.xcommon.UserWorkStatus} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setWorkstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional xcommon.TicketItemEnum TicketItemId = 9;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.userepb.SearchUserReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @return {!proto.userepb.SearchUserReq} returns this
 */
proto.userepb.SearchUserReq.prototype.setTicketitemid = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.SearchUserMiniReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.SearchUserMiniReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.SearchUserMiniReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.SearchUserMiniReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ticketitemid: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.SearchUserMiniReq}
 */
proto.userepb.SearchUserMiniReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.SearchUserMiniReq;
  return proto.userepb.SearchUserMiniReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.SearchUserMiniReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.SearchUserMiniReq}
 */
proto.userepb.SearchUserMiniReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.TicketItemEnum} */ (reader.readEnum());
      msg.setTicketitemid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.SearchUserMiniReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.SearchUserMiniReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.SearchUserMiniReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.SearchUserMiniReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTicketitemid();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.SearchUserMiniReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.SearchUserMiniReq} returns this
*/
proto.userepb.SearchUserMiniReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.SearchUserMiniReq} returns this
 */
proto.userepb.SearchUserMiniReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.SearchUserMiniReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.userepb.SearchUserMiniReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserMiniReq} returns this
 */
proto.userepb.SearchUserMiniReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.userepb.SearchUserMiniReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserMiniReq} returns this
 */
proto.userepb.SearchUserMiniReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroup = 4;
 * @return {string}
 */
proto.userepb.SearchUserMiniReq.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.SearchUserMiniReq} returns this
 */
proto.userepb.SearchUserMiniReq.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional xcommon.TicketItemEnum TicketItemId = 5;
 * @return {!proto.xcommon.TicketItemEnum}
 */
proto.userepb.SearchUserMiniReq.prototype.getTicketitemid = function() {
  return /** @type {!proto.xcommon.TicketItemEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.xcommon.TicketItemEnum} value
 * @return {!proto.userepb.SearchUserMiniReq} returns this
 */
proto.userepb.SearchUserMiniReq.prototype.setTicketitemid = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserByEmployeeIDReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserByEmployeeIDReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByEmployeeIDReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    employeeid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserByEmployeeIDReq}
 */
proto.userepb.GetUserByEmployeeIDReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserByEmployeeIDReq;
  return proto.userepb.GetUserByEmployeeIDReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserByEmployeeIDReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserByEmployeeIDReq}
 */
proto.userepb.GetUserByEmployeeIDReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserByEmployeeIDReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserByEmployeeIDReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByEmployeeIDReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetUserByEmployeeIDReq} returns this
*/
proto.userepb.GetUserByEmployeeIDReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserByEmployeeIDReq} returns this
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string EmployeeId = 2;
 * @return {string}
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserByEmployeeIDReq} returns this
 */
proto.userepb.GetUserByEmployeeIDReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserByMobileReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserByMobileReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserByMobileReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByMobileReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserByMobileReq}
 */
proto.userepb.GetUserByMobileReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserByMobileReq;
  return proto.userepb.GetUserByMobileReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserByMobileReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserByMobileReq}
 */
proto.userepb.GetUserByMobileReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserByMobileReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserByMobileReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserByMobileReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByMobileReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetUserByMobileReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetUserByMobileReq} returns this
*/
proto.userepb.GetUserByMobileReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserByMobileReq} returns this
 */
proto.userepb.GetUserByMobileReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserByMobileReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.userepb.GetUserByMobileReq.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserByMobileReq} returns this
 */
proto.userepb.GetUserByMobileReq.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserByEmailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserByEmailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserByEmailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByEmailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserByEmailReq}
 */
proto.userepb.GetUserByEmailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserByEmailReq;
  return proto.userepb.GetUserByEmailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserByEmailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserByEmailReq}
 */
proto.userepb.GetUserByEmailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserByEmailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserByEmailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserByEmailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserByEmailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetUserByEmailReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetUserByEmailReq} returns this
*/
proto.userepb.GetUserByEmailReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserByEmailReq} returns this
 */
proto.userepb.GetUserByEmailReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserByEmailReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Email = 2;
 * @return {string}
 */
proto.userepb.GetUserByEmailReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserByEmailReq} returns this
 */
proto.userepb.GetUserByEmailReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    userinfo: (f = msg.getUserinfo()) && xcommon_user_pb.UserInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserResp}
 */
proto.userepb.GetUserResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserResp;
  return proto.userepb.GetUserResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserResp}
 */
proto.userepb.GetUserResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_user_pb.UserInfo;
      reader.readMessage(value,xcommon_user_pb.UserInfo.deserializeBinaryFromReader);
      msg.setUserinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUserinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_user_pb.UserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.GetUserResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.GetUserResp} returns this
*/
proto.userepb.GetUserResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserResp} returns this
 */
proto.userepb.GetUserResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.UserInfo UserInfo = 2;
 * @return {?proto.xcommon.UserInfo}
 */
proto.userepb.GetUserResp.prototype.getUserinfo = function() {
  return /** @type{?proto.xcommon.UserInfo} */ (
    jspb.Message.getWrapperField(this, xcommon_user_pb.UserInfo, 2));
};


/**
 * @param {?proto.xcommon.UserInfo|undefined} value
 * @return {!proto.userepb.GetUserResp} returns this
*/
proto.userepb.GetUserResp.prototype.setUserinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserResp} returns this
 */
proto.userepb.GetUserResp.prototype.clearUserinfo = function() {
  return this.setUserinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserResp.prototype.hasUserinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserListReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserListReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserListReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usergroup: jspb.Message.getFieldWithDefault(msg, 5, ""),
    attendancetimefrom: jspb.Message.getFieldWithDefault(msg, 6, ""),
    attendancetimeto: jspb.Message.getFieldWithDefault(msg, 7, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 8, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    twofactauthrange: jspb.Message.getFieldWithDefault(msg, 10, 0),
    outsourcerange: jspb.Message.getFieldWithDefault(msg, 11, 0),
    userstatusrange: jspb.Message.getFieldWithDefault(msg, 12, 0),
    workstatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    exectype: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserListReq}
 */
proto.userepb.GetUserListReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserListReq;
  return proto.userepb.GetUserListReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserListReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserListReq}
 */
proto.userepb.GetUserListReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroup(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttendancetimefrom(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttendancetimeto(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.TwoFactAuthRange} */ (reader.readEnum());
      msg.setTwofactauthrange(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.OutSourceRange} */ (reader.readEnum());
      msg.setOutsourcerange(value);
      break;
    case 12:
      var value = /** @type {!proto.xcommon.UserStatusRange} */ (reader.readEnum());
      msg.setUserstatusrange(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.UserWorkStatusRange} */ (reader.readEnum());
      msg.setWorkstatus(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.ExecType} */ (reader.readEnum());
      msg.setExectype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserListReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserListReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserListReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsergroup();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAttendancetimefrom();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAttendancetimeto();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTwofactauthrange();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getOutsourcerange();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getUserstatusrange();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getWorkstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getExectype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetUserListReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetUserListReq} returns this
*/
proto.userepb.GetUserListReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserListReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.userepb.GetUserListReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.userepb.GetUserListReq} returns this
*/
proto.userepb.GetUserListReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserListReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string UserGroup = 5;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getUsergroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setUsergroup = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AttendanceTimeFrom = 6;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getAttendancetimefrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setAttendancetimefrom = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string AttendanceTimeTo = 7;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getAttendancetimeto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setAttendancetimeto = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 UserId = 8;
 * @return {number}
 */
proto.userepb.GetUserListReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string EmployeeId = 9;
 * @return {string}
 */
proto.userepb.GetUserListReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional xcommon.TwoFactAuthRange TwoFactAuthRange = 10;
 * @return {!proto.xcommon.TwoFactAuthRange}
 */
proto.userepb.GetUserListReq.prototype.getTwofactauthrange = function() {
  return /** @type {!proto.xcommon.TwoFactAuthRange} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.xcommon.TwoFactAuthRange} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setTwofactauthrange = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional xcommon.OutSourceRange OutSourceRange = 11;
 * @return {!proto.xcommon.OutSourceRange}
 */
proto.userepb.GetUserListReq.prototype.getOutsourcerange = function() {
  return /** @type {!proto.xcommon.OutSourceRange} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.xcommon.OutSourceRange} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setOutsourcerange = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional xcommon.UserStatusRange UserStatusRange = 12;
 * @return {!proto.xcommon.UserStatusRange}
 */
proto.userepb.GetUserListReq.prototype.getUserstatusrange = function() {
  return /** @type {!proto.xcommon.UserStatusRange} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.xcommon.UserStatusRange} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setUserstatusrange = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional xcommon.UserWorkStatusRange WorkStatus = 13;
 * @return {!proto.xcommon.UserWorkStatusRange}
 */
proto.userepb.GetUserListReq.prototype.getWorkstatus = function() {
  return /** @type {!proto.xcommon.UserWorkStatusRange} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.xcommon.UserWorkStatusRange} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setWorkstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional xcommon.ExecType ExecType = 14;
 * @return {!proto.xcommon.ExecType}
 */
proto.userepb.GetUserListReq.prototype.getExectype = function() {
  return /** @type {!proto.xcommon.ExecType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.xcommon.ExecType} value
 * @return {!proto.userepb.GetUserListReq} returns this
 */
proto.userepb.GetUserListReq.prototype.setExectype = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.GetUserListResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserListResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserListResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserListResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    userinfosList: jspb.Message.toObjectList(msg.getUserinfosList(),
    xcommon_user_pb.UserInfo.toObject, includeInstance),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserListResp}
 */
proto.userepb.GetUserListResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserListResp;
  return proto.userepb.GetUserListResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserListResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserListResp}
 */
proto.userepb.GetUserListResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_user_pb.UserInfo;
      reader.readMessage(value,xcommon_user_pb.UserInfo.deserializeBinaryFromReader);
      msg.addUserinfos(value);
      break;
    case 3:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserListResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserListResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserListResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUserinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_user_pb.UserInfo.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.GetUserListResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.GetUserListResp} returns this
*/
proto.userepb.GetUserListResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserListResp} returns this
 */
proto.userepb.GetUserListResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserListResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated xcommon.UserInfo UserInfos = 2;
 * @return {!Array<!proto.xcommon.UserInfo>}
 */
proto.userepb.GetUserListResp.prototype.getUserinfosList = function() {
  return /** @type{!Array<!proto.xcommon.UserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_user_pb.UserInfo, 2));
};


/**
 * @param {!Array<!proto.xcommon.UserInfo>} value
 * @return {!proto.userepb.GetUserListResp} returns this
*/
proto.userepb.GetUserListResp.prototype.setUserinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.UserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserInfo}
 */
proto.userepb.GetUserListResp.prototype.addUserinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.UserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.GetUserListResp} returns this
 */
proto.userepb.GetUserListResp.prototype.clearUserinfosList = function() {
  return this.setUserinfosList([]);
};


/**
 * optional xcommon.PageOut PageOut = 3;
 * @return {?proto.xcommon.PageOut}
 */
proto.userepb.GetUserListResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 3));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.userepb.GetUserListResp} returns this
*/
proto.userepb.GetUserListResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserListResp} returns this
 */
proto.userepb.GetUserListResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserListResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.GetUserListMiniResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetUserListMiniResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetUserListMiniResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetUserListMiniResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListMiniResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    userinfosList: jspb.Message.toObjectList(msg.getUserinfosList(),
    xcommon_user_pb.UserInfoMini.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetUserListMiniResp}
 */
proto.userepb.GetUserListMiniResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetUserListMiniResp;
  return proto.userepb.GetUserListMiniResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetUserListMiniResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetUserListMiniResp}
 */
proto.userepb.GetUserListMiniResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_user_pb.UserInfoMini;
      reader.readMessage(value,xcommon_user_pb.UserInfoMini.deserializeBinaryFromReader);
      msg.addUserinfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetUserListMiniResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetUserListMiniResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetUserListMiniResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetUserListMiniResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUserinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_user_pb.UserInfoMini.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.GetUserListMiniResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.GetUserListMiniResp} returns this
*/
proto.userepb.GetUserListMiniResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetUserListMiniResp} returns this
 */
proto.userepb.GetUserListMiniResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetUserListMiniResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated xcommon.UserInfoMini UserInfos = 2;
 * @return {!Array<!proto.xcommon.UserInfoMini>}
 */
proto.userepb.GetUserListMiniResp.prototype.getUserinfosList = function() {
  return /** @type{!Array<!proto.xcommon.UserInfoMini>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_user_pb.UserInfoMini, 2));
};


/**
 * @param {!Array<!proto.xcommon.UserInfoMini>} value
 * @return {!proto.userepb.GetUserListMiniResp} returns this
*/
proto.userepb.GetUserListMiniResp.prototype.setUserinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.UserInfoMini=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UserInfoMini}
 */
proto.userepb.GetUserListMiniResp.prototype.addUserinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.UserInfoMini, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.GetUserListMiniResp} returns this
 */
proto.userepb.GetUserListMiniResp.prototype.clearUserinfosList = function() {
  return this.setUserinfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetOptionsForAttendanceReportReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetOptionsForAttendanceReportReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetOptionsForAttendanceReportReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOptionsForAttendanceReportReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetOptionsForAttendanceReportReq}
 */
proto.userepb.GetOptionsForAttendanceReportReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetOptionsForAttendanceReportReq;
  return proto.userepb.GetOptionsForAttendanceReportReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetOptionsForAttendanceReportReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetOptionsForAttendanceReportReq}
 */
proto.userepb.GetOptionsForAttendanceReportReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetOptionsForAttendanceReportReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetOptionsForAttendanceReportReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetOptionsForAttendanceReportReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOptionsForAttendanceReportReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.GetOptionsForAttendanceReportReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.GetOptionsForAttendanceReportReq} returns this
*/
proto.userepb.GetOptionsForAttendanceReportReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetOptionsForAttendanceReportReq} returns this
 */
proto.userepb.GetOptionsForAttendanceReportReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetOptionsForAttendanceReportReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.GetOptionsForAttendanceReportResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.GetOptionsForAttendanceReportResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.GetOptionsForAttendanceReportResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOptionsForAttendanceReportResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    usergroupsList: jspb.Message.toObjectList(msg.getUsergroupsList(),
    xcommon_module_pb.Meta.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp}
 */
proto.userepb.GetOptionsForAttendanceReportResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.GetOptionsForAttendanceReportResp;
  return proto.userepb.GetOptionsForAttendanceReportResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.GetOptionsForAttendanceReportResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp}
 */
proto.userepb.GetOptionsForAttendanceReportResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_module_pb.Meta;
      reader.readMessage(value,xcommon_module_pb.Meta.deserializeBinaryFromReader);
      msg.addUsergroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.GetOptionsForAttendanceReportResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.GetOptionsForAttendanceReportResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.GetOptionsForAttendanceReportResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getUsergroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      xcommon_module_pb.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp} returns this
*/
proto.userepb.GetOptionsForAttendanceReportResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp} returns this
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated xcommon.Meta UserGroups = 2;
 * @return {!Array<!proto.xcommon.Meta>}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.getUsergroupsList = function() {
  return /** @type{!Array<!proto.xcommon.Meta>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_module_pb.Meta, 2));
};


/**
 * @param {!Array<!proto.xcommon.Meta>} value
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp} returns this
*/
proto.userepb.GetOptionsForAttendanceReportResp.prototype.setUsergroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.Meta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.Meta}
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.addUsergroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.Meta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.GetOptionsForAttendanceReportResp} returns this
 */
proto.userepb.GetOptionsForAttendanceReportResp.prototype.clearUsergroupsList = function() {
  return this.setUsergroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListGroupAttendanceReq.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListGroupAttendanceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListGroupAttendanceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListGroupAttendanceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    dateList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    underwhichusergroupsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListGroupAttendanceReq}
 */
proto.userepb.ListGroupAttendanceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListGroupAttendanceReq;
  return proto.userepb.ListGroupAttendanceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListGroupAttendanceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListGroupAttendanceReq}
 */
proto.userepb.ListGroupAttendanceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addDate(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUnderwhichusergroups(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListGroupAttendanceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListGroupAttendanceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListGroupAttendanceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getDateList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getUnderwhichusergroupsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      3,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.ListGroupAttendanceReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
*/
proto.userepb.ListGroupAttendanceReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListGroupAttendanceReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string Date = 2;
 * @return {!Array<string>}
 */
proto.userepb.ListGroupAttendanceReq.prototype.getDateList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.setDateList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.addDate = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.clearDateList = function() {
  return this.setDateList([]);
};


/**
 * repeated int64 UnderWhichUserGroups = 3;
 * @return {!Array<number>}
 */
proto.userepb.ListGroupAttendanceReq.prototype.getUnderwhichusergroupsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.setUnderwhichusergroupsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.addUnderwhichusergroups = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListGroupAttendanceReq} returns this
 */
proto.userepb.ListGroupAttendanceReq.prototype.clearUnderwhichusergroupsList = function() {
  return this.setUnderwhichusergroupsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListGroupAttendanceResp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListGroupAttendanceResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListGroupAttendanceResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListGroupAttendanceResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    attendancereportformList: jspb.Message.toObjectList(msg.getAttendancereportformList(),
    proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.toObject, includeInstance),
    attendancereportsummary: (f = msg.getAttendancereportsummary()) && proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListGroupAttendanceResp}
 */
proto.userepb.ListGroupAttendanceResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListGroupAttendanceResp;
  return proto.userepb.ListGroupAttendanceResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListGroupAttendanceResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListGroupAttendanceResp}
 */
proto.userepb.ListGroupAttendanceResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow;
      reader.readMessage(value,proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.deserializeBinaryFromReader);
      msg.addAttendancereportform(value);
      break;
    case 3:
      var value = new proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow;
      reader.readMessage(value,proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.deserializeBinaryFromReader);
      msg.setAttendancereportsummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListGroupAttendanceResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListGroupAttendanceResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListGroupAttendanceResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getAttendancereportformList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.serializeBinaryToWriter
    );
  }
  f = message.getAttendancereportsummary();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    stuffs: jspb.Message.getFieldWithDefault(msg, 3, 0),
    attendancestuffs: jspb.Message.getFieldWithDefault(msg, 4, 0),
    latestuffs: jspb.Message.getFieldWithDefault(msg, 5, 0),
    attendancerate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    laterate: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow;
  return proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStuffs(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAttendancestuffs(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLatestuffs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAttendancerate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLaterate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStuffs();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAttendancestuffs();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLatestuffs();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAttendancerate();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getLaterate();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string UserGroupName = 2;
 * @return {string}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setUsergroupname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 Stuffs = 3;
 * @return {number}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getStuffs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setStuffs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 AttendanceStuffs = 4;
 * @return {number}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getAttendancestuffs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setAttendancestuffs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 LateStuffs = 5;
 * @return {number}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getLatestuffs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setLatestuffs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double AttendanceRate = 6;
 * @return {number}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getAttendancerate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setAttendancerate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double LateRate = 7;
 * @return {number}
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.getLaterate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} returns this
 */
proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow.prototype.setLaterate = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.ListGroupAttendanceResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
*/
proto.userepb.ListGroupAttendanceResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
 */
proto.userepb.ListGroupAttendanceResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListGroupAttendanceResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OneAttendanceReportRow AttendanceReportForm = 2;
 * @return {!Array<!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow>}
 */
proto.userepb.ListGroupAttendanceResp.prototype.getAttendancereportformList = function() {
  return /** @type{!Array<!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow, 2));
};


/**
 * @param {!Array<!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow>} value
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
*/
proto.userepb.ListGroupAttendanceResp.prototype.setAttendancereportformList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow}
 */
proto.userepb.ListGroupAttendanceResp.prototype.addAttendancereportform = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
 */
proto.userepb.ListGroupAttendanceResp.prototype.clearAttendancereportformList = function() {
  return this.setAttendancereportformList([]);
};


/**
 * optional OneAttendanceReportRow AttendanceReportSummary = 3;
 * @return {?proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow}
 */
proto.userepb.ListGroupAttendanceResp.prototype.getAttendancereportsummary = function() {
  return /** @type{?proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow} */ (
    jspb.Message.getWrapperField(this, proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow, 3));
};


/**
 * @param {?proto.userepb.ListGroupAttendanceResp.OneAttendanceReportRow|undefined} value
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
*/
proto.userepb.ListGroupAttendanceResp.prototype.setAttendancereportsummary = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListGroupAttendanceResp} returns this
 */
proto.userepb.ListGroupAttendanceResp.prototype.clearAttendancereportsummary = function() {
  return this.setAttendancereportsummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListGroupAttendanceResp.prototype.hasAttendancereportsummary = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.StatementOfSalaryReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.StatementOfSalaryReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.StatementOfSalaryReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    payrollcyclecondition: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usergroupid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isnewemployee: jspb.Message.getFieldWithDefault(msg, 5, 0),
    employeeid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    employeename: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.StatementOfSalaryReq}
 */
proto.userepb.StatementOfSalaryReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.StatementOfSalaryReq;
  return proto.userepb.StatementOfSalaryReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.StatementOfSalaryReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.StatementOfSalaryReq}
 */
proto.userepb.StatementOfSalaryReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.PayrollCycleKind} */ (reader.readEnum());
      msg.setPayrollcyclecondition(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsergroupid(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.StuffLabel} */ (reader.readEnum());
      msg.setIsnewemployee(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.StatementOfSalaryReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.StatementOfSalaryReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.StatementOfSalaryReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getPayrollcyclecondition();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUsergroupid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsnewemployee();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmployeename();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.StatementOfSalaryReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
*/
proto.userepb.StatementOfSalaryReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.StatementOfSalaryReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.userepb.StatementOfSalaryReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
*/
proto.userepb.StatementOfSalaryReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.StatementOfSalaryReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional xcommon.PayrollCycleKind PayrollCycleCondition = 3;
 * @return {!proto.xcommon.PayrollCycleKind}
 */
proto.userepb.StatementOfSalaryReq.prototype.getPayrollcyclecondition = function() {
  return /** @type {!proto.xcommon.PayrollCycleKind} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.xcommon.PayrollCycleKind} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.setPayrollcyclecondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 UserGroupId = 4;
 * @return {number}
 */
proto.userepb.StatementOfSalaryReq.prototype.getUsergroupid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.setUsergroupid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional xcommon.StuffLabel IsNewEmployee = 5;
 * @return {!proto.xcommon.StuffLabel}
 */
proto.userepb.StatementOfSalaryReq.prototype.getIsnewemployee = function() {
  return /** @type {!proto.xcommon.StuffLabel} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.xcommon.StuffLabel} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.setIsnewemployee = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string EmployeeId = 6;
 * @return {string}
 */
proto.userepb.StatementOfSalaryReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string EmployeeName = 7;
 * @return {string}
 */
proto.userepb.StatementOfSalaryReq.prototype.getEmployeename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryReq} returns this
 */
proto.userepb.StatementOfSalaryReq.prototype.setEmployeename = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.StatementOfSalaryResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.StatementOfSalaryResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.StatementOfSalaryResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.StatementOfSalaryResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    statementofsalaryformList: jspb.Message.toObjectList(msg.getStatementofsalaryformList(),
    proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.StatementOfSalaryResp}
 */
proto.userepb.StatementOfSalaryResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.StatementOfSalaryResp;
  return proto.userepb.StatementOfSalaryResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.StatementOfSalaryResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.StatementOfSalaryResp}
 */
proto.userepb.StatementOfSalaryResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow;
      reader.readMessage(value,proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.deserializeBinaryFromReader);
      msg.addStatementofsalaryform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.StatementOfSalaryResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.StatementOfSalaryResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.StatementOfSalaryResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getStatementofsalaryformList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    payrollcycle: jspb.Message.getFieldWithDefault(msg, 1, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    employeename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    stuffentrytime: jspb.Message.getFieldWithDefault(msg, 5, ""),
    isnewemployee: jspb.Message.getFieldWithDefault(msg, 6, 0),
    monthlybasesalary: jspb.Message.getFieldWithDefault(msg, 7, 0),
    dailybasesalary: jspb.Message.getFieldWithDefault(msg, 8, 0),
    totalsalary: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isemployeeidstartwithfive: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow;
  return proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayrollcycle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeename(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStuffentrytime(value);
      break;
    case 6:
      var value = /** @type {!proto.xcommon.StuffLabel} */ (reader.readEnum());
      msg.setIsnewemployee(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthlybasesalary(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDailybasesalary(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalsalary(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsemployeeidstartwithfive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPayrollcycle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmployeename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStuffentrytime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIsnewemployee();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getMonthlybasesalary();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getDailybasesalary();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTotalsalary();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getIsemployeeidstartwithfive();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string PayrollCycle = 1;
 * @return {string}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getPayrollcycle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setPayrollcycle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string EmployeeId = 2;
 * @return {string}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string EmployeeName = 3;
 * @return {string}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getEmployeename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setEmployeename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroupName = 4;
 * @return {string}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setUsergroupname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string StuffEntryTime = 5;
 * @return {string}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getStuffentrytime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setStuffentrytime = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional xcommon.StuffLabel IsNewEmployee = 6;
 * @return {!proto.xcommon.StuffLabel}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getIsnewemployee = function() {
  return /** @type {!proto.xcommon.StuffLabel} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.xcommon.StuffLabel} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setIsnewemployee = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 MonthlyBaseSalary = 7;
 * @return {number}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getMonthlybasesalary = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setMonthlybasesalary = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 DailyBaseSalary = 8;
 * @return {number}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getDailybasesalary = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setDailybasesalary = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 TotalSalary = 9;
 * @return {number}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getTotalsalary = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setTotalsalary = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool IsEmployeeIdStartWithFive = 10;
 * @return {boolean}
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.getIsemployeeidstartwithfive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow} returns this
 */
proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow.prototype.setIsemployeeidstartwithfive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.StatementOfSalaryResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
*/
proto.userepb.StatementOfSalaryResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
 */
proto.userepb.StatementOfSalaryResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.StatementOfSalaryResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.userepb.StatementOfSalaryResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
*/
proto.userepb.StatementOfSalaryResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
 */
proto.userepb.StatementOfSalaryResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.StatementOfSalaryResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OneStatementOfSalaryRow StatementOfSalaryForm = 3;
 * @return {!Array<!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow>}
 */
proto.userepb.StatementOfSalaryResp.prototype.getStatementofsalaryformList = function() {
  return /** @type{!Array<!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow, 3));
};


/**
 * @param {!Array<!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow>} value
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
*/
proto.userepb.StatementOfSalaryResp.prototype.setStatementofsalaryformList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow}
 */
proto.userepb.StatementOfSalaryResp.prototype.addStatementofsalaryform = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.userepb.StatementOfSalaryResp.OneStatementOfSalaryRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.StatementOfSalaryResp} returns this
 */
proto.userepb.StatementOfSalaryResp.prototype.clearStatementofsalaryformList = function() {
  return this.setStatementofsalaryformList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListPersonalAttendancePreRangeReq.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreRangeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    startdate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    enddate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    usergroupidsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    email: jspb.Message.getFieldWithDefault(msg, 7, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreRangeReq;
  return proto.userepb.ListPersonalAttendancePreRangeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartdate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnddate(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUsergroupids(values[i]);
      }
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreRangeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getStartdate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnddate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsergroupidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
*/
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
*/
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string StartDate = 3;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getStartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setStartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string EndDate = 4;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getEnddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setEnddate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated int64 UserGroupIds = 5;
 * @return {!Array<number>}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getUsergroupidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setUsergroupidsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.addUsergroupids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.clearUsergroupidsList = function() {
  return this.setUsergroupidsList([]);
};


/**
 * optional string Name = 6;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Email = 7;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string EmployeeId = 8;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeReq} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListPersonalAttendancePreRangeResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreRangeResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    personalattendancerowsList: jspb.Message.toObjectList(msg.getPersonalattendancerowsList(),
    proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreRangeResp;
  return proto.userepb.ListPersonalAttendancePreRangeResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow;
      reader.readMessage(value,proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.deserializeBinaryFromReader);
      msg.addPersonalattendancerows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreRangeResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getPersonalattendancerowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    daterange: jspb.Message.getFieldWithDefault(msg, 1, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    shouldattendancedays: jspb.Message.getFieldWithDefault(msg, 5, 0),
    actualattendancedays: jspb.Message.getFieldWithDefault(msg, 6, 0),
    workdayattendancedays: jspb.Message.getFieldWithDefault(msg, 7, 0),
    weekendattendancedays: jspb.Message.getFieldWithDefault(msg, 8, 0),
    entrydate: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow;
  return proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldattendancedays(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActualattendancedays(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWorkdayattendancedays(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWeekendattendancedays(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntrydate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShouldattendancedays();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getActualattendancedays();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getWorkdayattendancedays();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getWeekendattendancedays();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getEntrydate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string DateRange = 1;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setDaterange = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string EmployeeId = 2;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroupName = 4;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setUsergroupname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 ShouldAttendanceDays = 5;
 * @return {number}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getShouldattendancedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setShouldattendancedays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 ActualAttendanceDays = 6;
 * @return {number}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getActualattendancedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setActualattendancedays = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 WorkDayAttendanceDays = 7;
 * @return {number}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getWorkdayattendancedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setWorkdayattendancedays = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 WeekendAttendanceDays = 8;
 * @return {number}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getWeekendattendancedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setWeekendattendancedays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string EntryDate = 9;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.getEntrydate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow.prototype.setEntrydate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
*/
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
*/
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OnePersonalAttendanceRow PersonalAttendanceRows = 3;
 * @return {!Array<!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow>}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.getPersonalattendancerowsList = function() {
  return /** @type{!Array<!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow, 3));
};


/**
 * @param {!Array<!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow>} value
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
*/
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.setPersonalattendancerowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow}
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.addPersonalattendancerows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.userepb.ListPersonalAttendancePreRangeResp.OnePersonalAttendanceRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListPersonalAttendancePreRangeResp} returns this
 */
proto.userepb.ListPersonalAttendancePreRangeResp.prototype.clearPersonalattendancerowsList = function() {
  return this.setPersonalattendancerowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListPersonalAttendancePreDayReq.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreDayReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    pagein: (f = msg.getPagein()) && xcommon_common_pb.PageIn.toObject(includeInstance, f),
    daterange: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    email: jspb.Message.getFieldWithDefault(msg, 6, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    usergroupidsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq}
 */
proto.userepb.ListPersonalAttendancePreDayReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreDayReq;
  return proto.userepb.ListPersonalAttendancePreDayReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq}
 */
proto.userepb.ListPersonalAttendancePreDayReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageIn;
      reader.readMessage(value,xcommon_common_pb.PageIn.deserializeBinaryFromReader);
      msg.setPagein(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDaterange(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUsergroupids(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreDayReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreDayReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getPagein();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageIn.serializeBinaryToWriter
    );
  }
  f = message.getDaterange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUsergroupidsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      8,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
*/
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageIn PageIn = 2;
 * @return {?proto.xcommon.PageIn}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getPagein = function() {
  return /** @type{?proto.xcommon.PageIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageIn, 2));
};


/**
 * @param {?proto.xcommon.PageIn|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
*/
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setPagein = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.clearPagein = function() {
  return this.setPagein(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.hasPagein = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string DateRange = 3;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getDaterange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setDaterange = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 UserId = 4;
 * @return {number}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Email = 6;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string EmployeeId = 7;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated int64 UserGroupIds = 8;
 * @return {!Array<number>}
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.getUsergroupidsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.setUsergroupidsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.addUsergroupids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListPersonalAttendancePreDayReq} returns this
 */
proto.userepb.ListPersonalAttendancePreDayReq.prototype.clearUsergroupidsList = function() {
  return this.setUsergroupidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.ListPersonalAttendancePreDayResp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreDayResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    pageout: (f = msg.getPageout()) && xcommon_common_pb.PageOut.toObject(includeInstance, f),
    personalattendancedetailrowsList: jspb.Message.toObjectList(msg.getPersonalattendancedetailrowsList(),
    proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp}
 */
proto.userepb.ListPersonalAttendancePreDayResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreDayResp;
  return proto.userepb.ListPersonalAttendancePreDayResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp}
 */
proto.userepb.ListPersonalAttendancePreDayResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = new xcommon_common_pb.PageOut;
      reader.readMessage(value,xcommon_common_pb.PageOut.deserializeBinaryFromReader);
      msg.setPageout(value);
      break;
    case 3:
      var value = new proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow;
      reader.readMessage(value,proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.deserializeBinaryFromReader);
      msg.addPersonalattendancedetailrows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreDayResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getPageout();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      xcommon_common_pb.PageOut.serializeBinaryToWriter
    );
  }
  f = message.getPersonalattendancedetailrowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usergroupname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    attendancetime: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow;
  return proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsergroupname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttendancetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsergroupname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAttendancetime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string Date = 1;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string EmployeeId = 2;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setEmployeeid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UserGroupName = 4;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getUsergroupname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setUsergroupname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Status = 5;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AttendanceTime = 6;
 * @return {string}
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.getAttendancetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow.prototype.setAttendancetime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
*/
proto.userepb.ListPersonalAttendancePreDayResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional xcommon.PageOut PageOut = 2;
 * @return {?proto.xcommon.PageOut}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.getPageout = function() {
  return /** @type{?proto.xcommon.PageOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.PageOut, 2));
};


/**
 * @param {?proto.xcommon.PageOut|undefined} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
*/
proto.userepb.ListPersonalAttendancePreDayResp.prototype.setPageout = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.clearPageout = function() {
  return this.setPageout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.hasPageout = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated OnePersonalAttendanceDetailRow PersonalAttendanceDetailRows = 3;
 * @return {!Array<!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow>}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.getPersonalattendancedetailrowsList = function() {
  return /** @type{!Array<!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow, 3));
};


/**
 * @param {!Array<!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow>} value
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
*/
proto.userepb.ListPersonalAttendancePreDayResp.prototype.setPersonalattendancedetailrowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow}
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.addPersonalattendancedetailrows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.userepb.ListPersonalAttendancePreDayResp.OnePersonalAttendanceDetailRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.ListPersonalAttendancePreDayResp} returns this
 */
proto.userepb.ListPersonalAttendancePreDayResp.prototype.clearPersonalattendancedetailrowsList = function() {
  return this.setPersonalattendancedetailrowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.userepb.BatchGetLoginInfoReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.BatchGetLoginInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.BatchGetLoginInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.BatchGetLoginInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchGetLoginInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonin: (f = msg.getCommonin()) && xcommon_common_pb.CommonIn.toObject(includeInstance, f),
    useridList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.BatchGetLoginInfoReq}
 */
proto.userepb.BatchGetLoginInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.BatchGetLoginInfoReq;
  return proto.userepb.BatchGetLoginInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.BatchGetLoginInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.BatchGetLoginInfoReq}
 */
proto.userepb.BatchGetLoginInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonIn;
      reader.readMessage(value,xcommon_common_pb.CommonIn.deserializeBinaryFromReader);
      msg.setCommonin(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUserid(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.BatchGetLoginInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.BatchGetLoginInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.BatchGetLoginInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchGetLoginInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonIn.serializeBinaryToWriter
    );
  }
  f = message.getUseridList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional xcommon.CommonIn CommonIn = 1;
 * @return {?proto.xcommon.CommonIn}
 */
proto.userepb.BatchGetLoginInfoReq.prototype.getCommonin = function() {
  return /** @type{?proto.xcommon.CommonIn} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonIn, 1));
};


/**
 * @param {?proto.xcommon.CommonIn|undefined} value
 * @return {!proto.userepb.BatchGetLoginInfoReq} returns this
*/
proto.userepb.BatchGetLoginInfoReq.prototype.setCommonin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.BatchGetLoginInfoReq} returns this
 */
proto.userepb.BatchGetLoginInfoReq.prototype.clearCommonin = function() {
  return this.setCommonin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.BatchGetLoginInfoReq.prototype.hasCommonin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated int64 UserId = 2;
 * @return {!Array<number>}
 */
proto.userepb.BatchGetLoginInfoReq.prototype.getUseridList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.userepb.BatchGetLoginInfoReq} returns this
 */
proto.userepb.BatchGetLoginInfoReq.prototype.setUseridList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.userepb.BatchGetLoginInfoReq} returns this
 */
proto.userepb.BatchGetLoginInfoReq.prototype.addUserid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.userepb.BatchGetLoginInfoReq} returns this
 */
proto.userepb.BatchGetLoginInfoReq.prototype.clearUseridList = function() {
  return this.setUseridList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.userepb.BatchGetLoginInfoResp.prototype.toObject = function(opt_includeInstance) {
  return proto.userepb.BatchGetLoginInfoResp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.userepb.BatchGetLoginInfoResp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchGetLoginInfoResp.toObject = function(includeInstance, msg) {
  var f, obj = {
    commonout: (f = msg.getCommonout()) && xcommon_common_pb.CommonOut.toObject(includeInstance, f),
    logininfomapMap: (f = msg.getLogininfomapMap()) ? f.toObject(includeInstance, proto.xcommon.LoginInfo.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.userepb.BatchGetLoginInfoResp}
 */
proto.userepb.BatchGetLoginInfoResp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.userepb.BatchGetLoginInfoResp;
  return proto.userepb.BatchGetLoginInfoResp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.userepb.BatchGetLoginInfoResp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.userepb.BatchGetLoginInfoResp}
 */
proto.userepb.BatchGetLoginInfoResp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.CommonOut;
      reader.readMessage(value,xcommon_common_pb.CommonOut.deserializeBinaryFromReader);
      msg.setCommonout(value);
      break;
    case 2:
      var value = msg.getLogininfomapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.xcommon.LoginInfo.deserializeBinaryFromReader, 0, new proto.xcommon.LoginInfo());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.userepb.BatchGetLoginInfoResp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.userepb.BatchGetLoginInfoResp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.userepb.BatchGetLoginInfoResp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.userepb.BatchGetLoginInfoResp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommonout();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      xcommon_common_pb.CommonOut.serializeBinaryToWriter
    );
  }
  f = message.getLogininfomapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.xcommon.LoginInfo.serializeBinaryToWriter);
  }
};


/**
 * optional xcommon.CommonOut CommonOut = 1;
 * @return {?proto.xcommon.CommonOut}
 */
proto.userepb.BatchGetLoginInfoResp.prototype.getCommonout = function() {
  return /** @type{?proto.xcommon.CommonOut} */ (
    jspb.Message.getWrapperField(this, xcommon_common_pb.CommonOut, 1));
};


/**
 * @param {?proto.xcommon.CommonOut|undefined} value
 * @return {!proto.userepb.BatchGetLoginInfoResp} returns this
*/
proto.userepb.BatchGetLoginInfoResp.prototype.setCommonout = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.userepb.BatchGetLoginInfoResp} returns this
 */
proto.userepb.BatchGetLoginInfoResp.prototype.clearCommonout = function() {
  return this.setCommonout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.userepb.BatchGetLoginInfoResp.prototype.hasCommonout = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * map<int64, xcommon.LoginInfo> LoginInfoMap = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.xcommon.LoginInfo>}
 */
proto.userepb.BatchGetLoginInfoResp.prototype.getLogininfomapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.xcommon.LoginInfo>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      proto.xcommon.LoginInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.userepb.BatchGetLoginInfoResp} returns this
 */
proto.userepb.BatchGetLoginInfoResp.prototype.clearLogininfomapMap = function() {
  this.getLogininfomapMap().clear();
  return this;
};


module.exports = proto.userepb;
